export var SubscriptionVerficationStatus;
(function (SubscriptionVerficationStatus) {
    SubscriptionVerficationStatus["VERIFIED"] = "verified";
    SubscriptionVerficationStatus["UNVERIFIED"] = "unverified";
    SubscriptionVerficationStatus["FAILED"] = "failed";
})(SubscriptionVerficationStatus || (SubscriptionVerficationStatus = {}));
//# sourceMappingURL=subscription.js.map